import React from 'react';
import PropTypes from 'prop-types';
// MODULES
import selectSearchFilter from 'lib/helpers/GeneralHelpers';
// APOLLO
import { graphql } from 'react-apollo';
import GET_CLIENTS_FORM from 'ApolloClient/Queries/getClientsForm';
// ANTD
import Form from 'antd/lib/form';
import Select from 'antd/lib/select';

// CONSTANTS AND DESTRUCTURING
// ================================================================
const Option = Select.Option;
const FormItem = Form.Item;

const getClientFullName = client => {
  let fullName = '';
  if (client.firstName) {
    fullName = client.firstName;
  }
  if (client.lastName) {
    fullName = `${fullName} ${client.lastName}`;
  }
  return fullName;
};

// EXPORTED COMPONENT
// ================================================================
export const FormComponent = ({
  form, data, initialValue, disabled, required,
}) => {
  const { getFieldDecorator } = form;

  // if (data.loading) { return null }
  if (data.loading) {
    return <span>Loading...</span>;
  }

  let rules = [{ required, message: 'Please input a client!' }];
  let options = data.getClientsForm || [];

  return (
    <FormItem label="Client">
      {getFieldDecorator('clientId', { rules, initialValue })(
        <Select
          disabled={disabled}
          showSearch
          size="large"
          optionFilterProp="children"
          filterOption={selectSearchFilter}
          allowClear
        >
          {options.length > 0
            ? options.map(client => (
              <Option key={client._id} value={client._id}>
                {getClientFullName(client)}
              </Option>
            ))
            : null}
        </Select>,
      )}
    </FormItem>
  );
};

FormComponent.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node]),
  prefix: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node]),
  form: PropTypes.object,
  initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.number, PropTypes.array]),
  message: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  valueName: PropTypes.string,
  rules: PropTypes.array,
};

// Specifies the default values for props:
FormComponent.defaultProps = {
  label: 'Password',
  prefix: null,
  initialValue: null,
  required: true,
  valueName: 'password',
  rules: [],
};

let ClientInputLegacy = graphql(GET_CLIENTS_FORM)(FormComponent);

// EXPORT
// ================================================================
export default ClientInputLegacy;



// WEBPACK FOOTER //
// ./src/components/inputs/ClientInputLegacy/index.js